import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-grid-system'
import textsData from '@/textData/UserProfileTexts.json'
import { useUserLanguage } from '@/customHooks'
import {
  NormalFormEmailField,
  NormalFormPhoneField,
  NormalFormTextField,
} from '../molecules'
import { capitalizeFirstLetter } from '@/helpers'
import { UserProfileFormProps } from '@/custom-types'

type EditProfileFormProps = {
  defaultProfileData: UserProfileFormProps | null
  onChange: (profileData: UserProfileFormProps) => void
}

const emptyData: UserProfileFormProps = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
}

export const  ProfileEditFormControlled = memo(({ defaultProfileData, onChange }: EditProfileFormProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.editProfile : textsData.en.editProfile

  const [initialProfileData, setInitialProfiletData] = useState<UserProfileFormProps>(defaultProfileData || emptyData)
  const profileDataRef = useRef<UserProfileFormProps>(defaultProfileData || emptyData)

  useEffect(() => {
    if (!defaultProfileData) return

    profileDataRef.current = defaultProfileData
    setInitialProfiletData(defaultProfileData)
  }, [defaultProfileData])

  const onFieldChangeHandle = useCallback((field: keyof UserProfileFormProps, value: string | null) => {
    if (!value) return

    profileDataRef.current = {
      ...profileDataRef.current,
      [field]: value
    }

    onChange(profileDataRef.current)
  }, [onChange])

  return (
    <>
      <Row>
        <Col md={6}>
          <NormalFormTextField
            name="profileFirstName"
            label={texts.firstName.label}
            placeholder={texts.firstName.placeholder}
            value={capitalizeFirstLetter(initialProfileData.firstName)}
            onChange={(value) => onFieldChangeHandle('firstName', value)}
          />
        </Col>
        <Col md={6}>
          <NormalFormTextField
            name="profileLastName"
            label={texts.lastName.label}
            placeholder={texts.lastName.placeholder}
            value={capitalizeFirstLetter(initialProfileData.lastName)}
            onChange={(value) => onFieldChangeHandle('lastName', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormEmailField
            name="profileEmail"
            label={texts.email.label}
            placeholder={texts.email.placeholder}
            value={initialProfileData.email}
            onChange={(value) => onFieldChangeHandle('email', value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormPhoneField
            name="profilePhoneNumber"
            label={texts.phoneNumber.label}
            placeholder={texts.phoneNumber.placeholder}
            value={initialProfileData.phoneNumber}
            onChange={(value) => onFieldChangeHandle('phoneNumber', value)}
          />
        </Col>
    </Row>
    </>
  )
})
